import type { CurrentUser } from "@/services/user";

/** 使用当前用户的权限字段控制菜单和按钮；后端仍独立校验权限。 */
export default function access(
  initialState: { currentUser?: CurrentUser } | undefined
) {
  const currentUser = initialState?.currentUser;
  const canSuperAdmin = Number(currentUser?.is_super_admin) === 1;
  return {
    canSuperAdmin,
    canAdmin: canSuperAdmin || Number(currentUser?.is_admin) === 1,
  };
}
